import { omit } from "ramda";
import { requestApi } from "core/api";
import { toFormData } from "core/utils";

export const signIn = ({ body }) =>
  requestApi({
    path: "/profile/sign-in/",
    method: "POST",
    body
  });

export const signUp = ({ body }) =>
  requestApi({
    path: "/profile/users/",
    method: "POST",
    body: toFormData(body),
    headers: omit(["content-type"]),
    config: {
      stringify: false
    }
  });

export const submitToNewsLetter = ({ body }) =>
  requestApi({
    path: "https://cms.thelobby.io/api/v1/newsletter/subscribe/",
    method: "POST",
    body
  });



// WEBPACK FOOTER //
// ./src/modules/user/auth/endpoints.js